import React from 'react';
import { Paper, PaperProps } from '@mui/material';

// 👇 extend ALL Paper props (includes mouse events, click, etc.)
export default function Card({ children, sx, ...rest }: PaperProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 4,
        border: '1px solid #eee',
        transition: 'all 0.25s ease', // optional but nice
        ...sx
      }}
      {...rest} // 👈 THIS is the critical fix
    >
      {children}
    </Paper>
  );
}